import React from "react";

export default function PageHeader({ title, subtitle, actions, children }) {
    return (
        <div className="mb-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
            <div>
                <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-sm text-slate-500 mt-1 max-w-2xl">{subtitle}</p>
                )}
                {children}
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
    );
}
